import { render, staticRenderFns } from "./ProductCollect.vue?vue&type=template&id=5f25c338&scoped=true&"
import script from "./ProductCollect.vue?vue&type=script&lang=js&"
export * from "./ProductCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f25c338",
  null
  
)

export default component.exports